import type { SxProps, Theme } from '@mui/material/styles';

export const carouselStyles: Record<string, SxProps<Theme>> = {
  root: (theme) => ({
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: 'minmax(280px, 474px) 1fr' },
    gap: { xs: theme.spacing(4), md: theme.spacing(6) },
    alignItems: { xs: 'center', md: 'stretch' },
    paddingInline: { xs: theme.spacing(3), md: 'clamp(32px, 5vw, 80px)' },
    paddingBlock: { xs: theme.spacing(8), md: 'clamp(64px, 7vw, 120px)' },
    width: '100%',
    maxWidth: 1320,
    marginInline: 'auto',
  }),
  // Viewport clips the sliding track; wrapper holds the square ratio.
  graphicWrap: {
    position: 'relative',
    width: '100%',
    maxWidth: 474,
    marginInline: { xs: 'auto', md: 0 },
    alignSelf: { md: 'center' },
    aspectRatio: '711 / 713',
    overflow: 'hidden',
  },
  // Row of full-width slides; slid horizontally via translateX.
  track: {
    display: 'flex',
    width: '100%',
    height: '100%',
    transition: 'transform 500ms ease',
  },
  slideImg: {
    flex: '0 0 100%',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  copy: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    minWidth: 0,
  },
  heading: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    // Figma: Manrope Medium 40 / 48.
    fontSize: { xs: '1.75rem', md: '2rem', lg: '2.5rem' },
    lineHeight: { xs: 1.2, lg: '3rem' },
    color: theme.palette.text.primary,
    margin: 0,
  }),
  body: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    // Figma: Manrope Medium 24 / 40.
    fontSize: { xs: '1rem', md: '1.125rem', lg: '1.5rem' },
    lineHeight: { xs: 1.55, lg: '2.5rem' },
    color: theme.palette.text.primary,
  }),
  controls: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    // Pin to the bottom of the (stretched) copy column so the dots + arrow
    // hold a fixed position regardless of each slide's text length.
    marginTop: { md: 'auto' },
    paddingTop: theme.spacing(2),
  }),
  dots: {
    display: 'inline-flex',
    gap: 1.5,
  },
  dot: (theme) => ({
    width: 12,
    height: 12,
    padding: 0,
    boxSizing: 'border-box',
    borderRadius: '999px',
    border: `1.5px solid ${theme.palette.primary.main}`,
    backgroundColor: 'transparent',
    cursor: 'pointer',
  }),
  dotActive: (theme) => ({
    backgroundColor: theme.palette.primary.main,
  }),
  nextButton: (theme) => ({
    minWidth: 68,
    width: 68,
    height: 44,
    borderRadius: '999px',
    padding: 0,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    transition: 'background-color 200ms ease',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  }),
};
